import {createRouter, createWebHistory} from "vue-router";
import {useMessageStore} from './stores/message-store';

// https://stackoverflow.com/a/66695008
import i18n from "./i18n";
const {t} = i18n.global;

import {app} from './main';

const router = createRouter({
    //mode: "history",
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            alias: '/dashboard', // just needed for dev, because my vite seems to use old files for '/'
            component: () => import('./components/dashboard.vue'),
            // FIXME: remove with prototype2
            meta: { requiresAuth: true, requiresH100: true, dependsOnGoals: true }
        },
        /*{
            path: '/curve',
            component: () => import('./components/curve')
        },*/
        {
            path: '/video',
            component: () => import('./components/video.vue'),
            meta: {requiresAuth: true, headerMenu: "videos"}
        },
        {
            path: '/videos',
            component: () => import('./components/videos.vue'),
            meta: {requiresAuth: true, headerMenu: "videos"}
        },
        {
            path: '/settings',
            component: () => import('./components/settings.vue'),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/review-settings', // ... same page called from user administration
            component: () => import('./components/settings.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/support',
            component: () => import('./components/support.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/faq',
            component: () => import('./components/faq.vue'),
            meta: {requiresAuth: false, headerMenu: 'help'}
        },
        {
            path: '/imprint',
            component: () => import('./components/imprint.vue'),
            meta: {requiresAuth: false}
        },
        {
            path: '/terms',
            component: () => import('./components/terms.vue'),
            meta: {requiresAuth: false}
        },
        {
            path: '/requirements',
            component: () => import('./components/requirements.vue'),
            meta: {requiresAuth: false}
        },
        {
            path: '/flunatic.Web',
            component: () => import('./components/flunatic-web.vue'),
            meta: {requiresAuth: false}
        },
        {
            path: '/support-user',
            // handled by a common page
            component: () => import("./components/support-messages.vue"),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/support-me',
            // handled by a common page
            component: () => import("./components/support-messages.vue"),
            meta: {requiresAuth: true, headerMenu: "help"}
        },
        {
            path: '/advice',
            component: () => import('./components/advice.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/advice-me',
            // handled by a common page
            component: () => import('./components/advice-messages.vue'),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/advice-user',
            // handled by a common page
            component: () => import('./components/advice-messages.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/chat',
            component: () => import('./components/chat.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/chat-my-course',
            // handled by a common page
            component: () => import("./components/chat-messages.vue"),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/chat-course',
            // handled by a common page
            component: () => import("./components/chat-messages.vue"),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/news-mine', // displaying my therapy news and my role news
            // handled by a common page
            component: () => import("./components/news-messages.vue"),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
         {
            path: '/news', // displaying admin's overview for news
            component: () => import("./components/news.vue"),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/news-therapy', // news of a given therapy
            // handled by a common page
            component: () => import("./components/news-messages.vue"),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/news-role', // news of a given role
            // handled by a common page
            component: () => import("./components/news-messages.vue"),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-users',
            component: () => import('./components/admin-users.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-therapies',
            component: () => import('./components/admin-therapies.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-therapy',
            component: () => import('./components/admin-therapy.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-book',
            component: () => import('./components/admin-book.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-chapter',
            component: () => import('./components/admin-chapter.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-section',
            component: () => import('./components/admin-section.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-exercise',
            component: () => import('./components/admin-exercise.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-tag',
            component: () => import('./components/admin-tag.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-tags',
            component: () => import('./components/admin-tags.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-template',
            component: () => import('./components/admin-template.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-images',
            component: () => import('./components/admin-images.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-image',
            component: () => import('./components/admin-image.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/admin-faq',
            component: () => import('./components/admin-faq.vue'),
            meta: {requiresAuth: false, headerMenu: 'admin'}
        },
        {
            path: '/eval-overview', // from admin-users: seeEvaluationDetails ...
            component: () => import('./components/eval-overview.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/chronicle-overview', // ... same page called from from menu->account->chronicle
            component: () => import('./components/eval-overview.vue'),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/eval', // for other users
            component: () => import('./components/eval.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/chronicle', // for self
            component: () => import('./components/eval.vue'),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/eval-week', 
            component: () => import('./components/eval-week.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/chronicle-week', // for self
            component: () => import('./components/eval-week.vue'),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/eval-day',
            component: () => import('./components/eval-day.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/chronicle-day', // for self
            component: () => import('./components/eval-day.vue'),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/eval-severities',
            component: () => import('./components/eval-severities.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/chronicle-severities', // for self
            component: () => import('./components/eval-severities.vue'),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/eval-focuses',
            component: () => import('./components/eval-focuses.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/chronicle-focuses', // for self
            component: () => import('./components/eval-focuses.vue'),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/eval-answers',
            component: () => import('./components/eval-answers.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/chronicle-answers', // for self
            component: () => import('./components/eval-answers.vue'),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/eval-quizzes',
            component: () => import('./components/eval-quizzes.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/chronicle-quizzes', // for self
            component: () => import('./components/eval-quizzes.vue'),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/eval-media',
            component: () => import('./components/eval-media.vue'),
            meta: {requiresAuth: true, headerMenu: 'admin'}
        },
        {
            path: '/chronicle-media', // for self
            component: () => import('./components/eval-media.vue'),
            meta: {requiresAuth: true, headerMenu: 'account'}
        },
        {
            path: '/therapy-:descriptiveId/book-:book/chapter-:chapter/section-:section/exercise-:exercise',
            component: () => import('./components/exercise.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/exercise-:exerciseId',
            component: () => import('./components/exercise.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/therapy-:descriptiveId/book-:book/chapter-:chapter/section-:section',
            component: () => import('./components/find-exercise.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/searchExercise-:exerciseId',
            component: () => import('./components/search-exercise.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/searchSection-:sectionId',
            component: () => import('./components/search-section.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/af',
            component: () => import('./components/af.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/lottie',
            component: () => import('./components/lottie.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/display',
            component: () => import('./components/display.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/re-logged-in',
            component: () => import('./components/re-logged-in.vue'),
            meta: {requiresAuth: true}
        },
        {
            path: '/register',
            component: () => import('./components/register.vue'),
            meta: {requiresAuth: false}
        }
        // when route not found, redirect to dashboard, currently w/o warning
        /*
        {   
            path: '/:pathMatch(.*)*', 
            redirect: '/' 
        }*/
    ]
});

let lastRoute = null;

router.beforeEach((to, from, next) => {
    const authRequired = to.matched.some(record => record.meta.requiresAuth);

    const authenticated = app.config.globalProperties.$keycloak.authenticated;
    //console.log("authenticated:", authenticated);

    // fix dropdown-menus not closing
    document.querySelectorAll('.dropdown-menu').forEach( e => {
        e.classList.remove("show");
    });

    // fix backdrop of modals not closing (https://stackoverflow.com/a/62107597)
    if (to.path != from.path)
        document.querySelectorAll('.modal-backdrop').forEach( e => {
            e.remove();
        });

    if (authRequired){
        if (!authenticated){
            // TODO: remove, because probably obselete now that we check token via interceptor, see ./main.js 
            console.log("authRequired but no user -> redirect to login");

            const basePath = window.location.origin.toString();
            const redirectUri = basePath + 
                /* prune away strange keycloak postfix!
                 especially important when session expired, because then
                 'to' looks like this: 
                    'http://localhost:8081/#error=login_required
                 which will cause an error when initializing keycloak after
                 login */
                to.fullPath.replace(/[#&]error.*/, "");

            if (navigator.serviceWorker.controller){
                app.config.globalProperties.$keycloak.login({redirectUri});
            } else {
                // wait for possible updates first

                // hmm, haven't observed this event so far
                navigator.serviceWorker.addEventListener('controllerchange', () => {
                    // sw updated and ready
                    app.config.globalProperties.$keycloak.login({redirectUri});
                });
            }
            
            return;

        }
    } else {
        // FIXME
        if (to.path == "/login" && authenticated){
            console.log("refusing to go to /login - already logged in. -> redirect to /");
            next('/');
        }
    }

    // Save the route you're coming from
    lastRoute = from.fullPath || null;

    next();
});

router.afterEach((to) => {
    // remove the ugly state parameter from keycloak.
    if (to.hash.includes('#state=')){
        const newPath = to.fullPath.replace(/#state=.*/, "");
        window.history.replaceState(null, "", newPath);
        //router.replace(newPath);
    }
    // state parameter after other hash, e.g. /faq#grantCameraPermission
    else if (to.hash.includes('&state=')){
        const newPath = to.fullPath.replace(/&state=.*/, "");
        window.history.replaceState(null, "", newPath);
        //router.replace(newPath);
    }
});

router.onError((error, to) => {
    const messageStore = useMessageStore();

    console.log(`route error: to=${to}, error:`, error);

     if (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes("Importing a module script failed")) {
         debugger;
         window.location = to.fullPath;
     }

    if (!navigator.onLine)
        messageStore.warn(t('errors.offline'));
    else
        messageStore.warn(t('errors.unknownError'));

});

export {router, lastRoute}
